import { render, staticRenderFns } from "./MyFriendsPopup.vue?vue&type=template&id=1e921b58&scoped=true&"
import script from "./MyFriendsPopup.vue?vue&type=script&lang=js&"
export * from "./MyFriendsPopup.vue?vue&type=script&lang=js&"
import style0 from "./MyFriendsPopup.vue?vue&type=style&index=0&id=1e921b58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e921b58",
  null
  
)

export default component.exports